import React, { useState, useRef } from 'react';
import { Input, Button, Typography } from '@hpstellar/core/visId';
import { ChevronUp, ChevronDown } from '@hpstellar/vis-icons';

export default ({ children, inputProps, errorMessage, isExpanded = false, className, onToggle }) => {
    const [expanded, setExpanded] = useState(isExpanded);
    const inputRef = useRef(null);
    const { onSubmit, ...restInputProps } = inputProps || {};
    const buttonProps = {
        onClick: () => onSubmit && onSubmit(inputRef.current.value),
        onKeyPress: event => event.key === 'Enter' && onSubmit && onSubmit(inputRef.current.value),
    };
    const expandedState = onToggle ? isExpanded : expanded;
    return (
        <div className={`toggle-section${className ? ` ${className}` : ''}`}>
            <div className="toggle-label">
                <span style={{ color: '#666' }}>Based on</span>
                <Button
                    theme="accent"
                    variation="tertiary"
                    onClick={() => {
                        if (onToggle) {
                            onToggle(!expanded);
                        } else {
                            setExpanded(!expanded);
                        }
                    }}
                    endIcon={expanded ? <ChevronUp /> : <ChevronDown />}
                >
                    {children}
                </Button>
            </div>
            {expandedState && inputProps && (
                <>
                    <div className="toggle-input-container">
                        <Input
                            ref={inputRef}
                            className="toggle-input"
                            slim={true}
                            {...restInputProps}
                            error={errorMessage}
                        />
                        <Button {...buttonProps} size="small">
                            Apply
                        </Button>
                    </div>
                    {errorMessage && (
                        <Typography variant="footnote" style={{ color: '#cc2c00' }}>
                            {errorMessage}
                        </Typography>
                    )}
                </>
            )}
        </div>
    );
};
